/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_DocumentsInputs */



/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Meeting_Sources_DocumentsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_documents = /** @type {((inputs?: Meeting_Sources_DocumentsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_DocumentsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Documenten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Documents")
	return /** @type {LocalizedString} */ ("Documents")
});